// jQuery
import jQuery from "jquery";
export default window.$ = window.jQuery = jQuery;
